module.exports = __webpack_public_path__ + "static/media/logo.c705dffa.png";